module.exports = __webpack_public_path__ + "media/img/vca/congrats-c1615d23b4b11b17987acde3960fb2aa.png";